import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { GraphicSidebar as Component } from './GraphicSidebar'
import {
  selectGroupedEditions,
  selectIsDeletedFilePresentInEditions,
} from '../../selectors/pack'
import { AppStateType } from '../../reducers'

const mapStateToProps = (state: AppStateType) => ({
  groupedEditions: selectGroupedEditions(state),
  isDeletedFilePresentInEditions: selectIsDeletedFilePresentInEditions(state),
})

export const GraphicSidebar = withRouter(connect(mapStateToProps)(Component))
